import { render, staticRenderFns } from "./AddTrades.vue?vue&type=template&id=5e6e7d96&"
import script from "./AddTrades.vue?vue&type=script&lang=js&"
export * from "./AddTrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports